import { render, staticRenderFns } from "./BoxItemNew.vue?vue&type=template&id=d1246708&"
import script from "./BoxItemNew.vue?vue&type=script&lang=js&"
export * from "./BoxItemNew.vue?vue&type=script&lang=js&"
import style0 from "./BoxItemNew.vue?vue&type=style&index=0&id=d1246708&prod&lang=css&"
import style1 from "./BoxItemNew.vue?vue&type=style&index=1&id=d1246708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports